/**
 * Example JavaScript singleton module
 */

var Contact = (function($) {
  function initContactFooterLinks() {
    $(document).on("click", ".js-contact-scroll", function(e) {
      e.preventDefault();

      var projectType = $(this).data("project-type");
      var $contact = $(".home-contact");
      var $radio = $('input[name="project-type"][value="' + projectType + '"]');

      if (!$contact.length) {
        return;
      }

      if ($radio.length) {
        $radio.prop("checked", true).trigger("change");
      }

      var headerHeight = $(".header").outerHeight() || 0;

      $("html, body").animate(
        {
          scrollTop: $contact.offset().top - headerHeight
        },
        1000
      );
    });
  }

  function init() {
    // return early if no corresponding module present
    if (!$(".home-contact").length) {
      return;
    }

    initContactFooterLinks();
  }

  return {
    init: init
  };
})(jQuery);

jQuery(document).ready(Contact.init);
